export default __webpack_public_path__ + "static/media/robotHandLight.97910085.png";